import React, { FC, useEffect } from 'react'
import ReactImageGallery, { ReactImageGalleryItem } from 'react-image-gallery'
import { ImageVariants, MediaDTO } from '@/core/media/typings'
import { Box, IconButton } from '@chakra-ui/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { ImageBox } from '@/app/components/common/ImageBox'
import { getDisplayImageUrl } from '@/core/media/utils/get-display-image-url'

interface ImageGalleryProps {
  medias: MediaDTO[]
  index: number
}

const ImageGallery: FC<ImageGalleryProps> = ({ medias, index }) => {
  let imgGallery: ReactImageGallery | null = null

  const setRef = (node: ReactImageGallery): void => {
    if (node) {
      imgGallery = node
    }
  }

  useEffect(() => {
    imgGallery?.slideToIndex(index)
  }, [index, imgGallery])

  return (
    <Box
      sx={{
        '.image-gallery': {
          marginTop: '5rem',
          maxWidth: 'full',
          width: 'full',
          margin: '0 auto'
        }
      }}
      alignSelf="center"
      w="full"
      h="full"
      mx="auto">
      <ReactImageGallery
        ref={setRef}
        showPlayButton={false}
        autoPlay={false}
        renderLeftNav={(onClick, isDisabled) => (
          <IconButton
            variant="ghost"
            bg="rgba(255,255,255,0.75)"
            rounded="full"
            icon={<ChevronLeftIcon boxSize={10} />}
            onClick={onClick}
            disabled={isDisabled}
            aria-label="Previous image"
            position="absolute"
            left="5px"
            top="50%"
            transform="translateY(-50%)"
            zIndex="modal"
          />
        )}
        renderRightNav={(onClick, isDisabled) => (
          <IconButton
            variant="ghost"
            bg="rgba(255,255,255,0.75)"
            rounded="full"
            icon={<ChevronRightIcon boxSize={10} />}
            onClick={onClick}
            disabled={isDisabled}
            aria-label="Next image"
            position="absolute"
            right="5px"
            top="50%"
            transform="translateY(-50%)"
            zIndex="modal"
          />
        )}
        items={medias
          .filter((m) => m.type !== 'pdf')
          .map((m) => ({
            original: m.url,
            thumbnail: getDisplayImageUrl(m.url, ImageVariants.thumb),
            renderItem(item: ReactImageGalleryItem): React.ReactNode {
              return (
                <ImageBox
                  w="full"
                  h="85vh"
                  cursor="pointer"
                  imgProps={{
                    alt: item.originalAlt || '',
                    src: item.original,
                    fill: true,
                    style: {
                      objectFit: 'contain'
                    },
                    quality: 100,
                    priority: true
                  }}
                />
              )
            }
          }))}
      />
    </Box>
  )
}

export default ImageGallery
